/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrganizationOptionScimUpdateRequest
 */
export interface OrganizationOptionScimUpdateRequest {
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationOptionScimUpdateRequest
     */
    enable: boolean;
}

/**
 * Check if a given object implements the OrganizationOptionScimUpdateRequest interface.
 */
export function instanceOfOrganizationOptionScimUpdateRequest(value: object): value is OrganizationOptionScimUpdateRequest {
    if (!('enable' in value) || value['enable'] === undefined) return false;
    return true;
}

export function OrganizationOptionScimUpdateRequestFromJSON(json: any): OrganizationOptionScimUpdateRequest {
    return OrganizationOptionScimUpdateRequestFromJSONTyped(json, false);
}

export function OrganizationOptionScimUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationOptionScimUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'enable': json['enable'],
    };
}

export function OrganizationOptionScimUpdateRequestToJSON(value?: OrganizationOptionScimUpdateRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'enable': value['enable'],
    };
}

